var map = {
	"./de-DE/btn_voted.png": "073a",
	"./en-GB/btn_voted.png": "1243",
	"./en-US/btn_voted.png": "4531",
	"./es-ES/btn_voted.png": "abc0",
	"./es-MX/btn_voted.png": "2b92",
	"./fr-CA/btn_voted.png": "4895",
	"./fr-FR/btn_voted.png": "ac62",
	"./it-IT/btn_voted.png": "ac9b",
	"./ja-JP/btn_voted.png": "5f86",
	"./pt-BR/btn_voted.png": "216f",
	"./zh-TW/btn_voted.png": "91e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9050";